import type { Agent, KnowledgeBase } from '../types';
import { api, ApiError } from './apiClient';
import { normalizeAgent, normalizeAgentList } from './normalizers';

export const agentsService = {
  async list(): Promise<Agent[]> {
    const res = await api.get<{ agents: unknown[] }>('/agents');
    return normalizeAgentList(res.agents);
  },

  async get(id: string): Promise<Agent | undefined> {
    try {
      const res = await api.get<{ agent: unknown }>(`/agents/${encodeURIComponent(id)}`);
      return normalizeAgent(res.agent);
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) return undefined;
      throw err;
    }
  },

  async save(agent: Agent): Promise<Agent> {
    const res = await api.post<{ agent: unknown }>('/agents', agent);
    return normalizeAgent(res.agent);
  },

  async remove(id: string): Promise<void> {
    await api.del(`/agents/${encodeURIComponent(id)}`);
  },

  async listKnowledgeBases(): Promise<KnowledgeBase[]> {
    const res = await api.get<{ knowledgeBases: KnowledgeBase[] }>('/knowledge-bases');
    return res.knowledgeBases;
  },

  async enhancePrompt(input: { prompt: string; name?: string; description?: string; model?: string; agentId?: string }): Promise<string> {
    const res = await api.post<{ prompt: string }>('/agents/enhance-prompt', input);
    return res.prompt;
  },
};
